module.exports = __webpack_public_path__ + "images/processed.png";


//////////////////
// WEBPACK FOOTER
// ./images/processed.png
// module id = 1127
// module chunks = 1